
export default function PageTitle(props) {
    return (
        <h5 className={props.titleClass}><i className='fa fa-info-circle'></i> {props.title}</h5>
    )
}
